export default function show_details() {
  try {
    const orders = document.querySelectorAll("[data-order-cut]");
    const ordersBlock = orders[0].parentElement;
    const details = document.querySelectorAll("[data-order-detail]");
    const detailsBlock = document.querySelector(".js-order-details");
    const detailsBack = document.querySelectorAll(".js-order-details-close");

    clear_detail();

    detailsBack.forEach((btn) => {
      btn.addEventListener("click", back_to_standart);
    });

    orders.forEach((order) =>
      order.addEventListener("click", () => {
        ordersBlock.classList.add("hidden");
        detailsBlock.classList.add("active");

        let num = order.getAttribute("data-order-cut");
        show_detail(num);
      })
    );

    function clear_detail() {
      details.forEach((detail) => detail.classList.add("hidden"));
    }

    function show_detail(i) {
      const detail = document.querySelector(`[data-order-detail="${i}"]`);
      detail.classList.remove("hidden");
    }

    function back_to_standart() {
      ordersBlock.classList.remove("hidden");
      detailsBlock.classList.remove("active");
      clear_detail();
    }
  } catch (e) {}
}
